const getCirclePercentage = (total, valueToCalculatePercentage, compareValue) => {
  return compareValue === 0 && valueToCalculatePercentage === 0 ? 0 : (valueToCalculatePercentage * 100) / total;
};

const getNumericEnumLength = (targetEnum: any) => Object.keys(targetEnum).length / 2;
export { getCirclePercentage, getNumericEnumLength };
